module.exports = __webpack_public_path__ + "static/media/36.3b1048fc.jpg";